// import {getProduct} from "../apis";

// function getById(id, start) {
//     return start.id === id && start || Array.isArray(start) && start.reduce((i, c) => i || getById(id, c), undefined) || typeof(start) === 'object' && Object.keys(start).reduce((i, k) => i || getById(id, start[k]), undefined)
// }

function extend() {
    // const $ = id => getById(id, root);

    // ($("ECore.AccessControl.frmSearchPermissionGroup.pgSearchPermissionGroup.AddNewPermissionGroup") || {}).targetRoute = {
    //     kind: "TExpr",
    //     $eval() {
    //         const route = this.defaultRoute()
    //         route.params.model = {FolderID: this.model.folderId}
    //         return route
    //     }
    // };

    // ($("ECore.AccessControl.frmBussinesUnit.pgBussinesUnit.addNewPost") || {}).targetRoute = {
    //     kind: "TExpr",
    //     $eval() {
    //         const route = this.defaultRoute()
    //         route.params.model = {BUID: this.model.folderId}
    //         return route
    //     }
    // };
        // ($("ICore.PolicyAdmin.frmSearchPolicy.Policy.AddNewPolicy") || {}).targetRoute = {
    //     kind: "TExpr",
    //     async $eval() {
    //         const route = this.defaultRoute();
    //         let product = null;
    //         getProduct(this.$route.query.ProductDefID).then(res => product = res);
    //         route.name = product.policyForm.id;
    //         route.params.model = { ProductDefID: product.name };
    //         route.params = {...route.params, formId: product.policyForm.id};
    //         return route;
    //     }
    // };

    /*       FUL                    */
    // ($("Comp.Products.LA.ProductSpec.FULProduct.PolicySearchForm.Policy.AddNewPolicy") || {}).targetRoute = {
    //     kind: "TExpr",
    //     async $eval() {
    //         const route = this.defaultRoute();
    //         let product;
    //         (async () => {
    //             product = await this.$getProduct(this.$route.query.ProductDefID);
    //         })();
    //         route.name = product.policyForm.id;
    //         route.params = {...route.params, formId: product.policyForm.id};
    //         route.params.model = { title: this.$t(product), ProductDefID: product.id };
    //         return route;
    //     }
    // };
    // ($("Comp.Products.LA.ProductSpec.FULProduct.PolicySearchForm.Policy.SearchConfig.AdvancedSearch.SearchResult.craDelete") || {}).targetRoute = {
    //     kind: "TExpr",
    //     async $eval() {
    //         const route = this.defaultRoute()
    //         const product = await this.$getProduct(this.$route.query.ProductDefID)
    //         route.name = product.policyForm.id
    //         route.params = {...route.params, formId: product.policyForm.id}
    //         route.params.model = { title: this.$t(product) };
    //         return route
    //     }
    // };

    // ($("Comp.Products.LA.ProductSpec.FULProduct.PolicySearchForm.Policy.SearchConfig.AdvancedSearch.SearchResult.craEdit") || {}).targetRoute = {
    //     kind: "TExpr",
    //     async $eval() {
    //         const route = this.defaultRoute()
    //         const product = await this.$getProduct(this.$route.query.ProductDefID)
    //         route.name = product.policyForm.id
    //         route.params = {...route.params, formId: product.policyForm.id}
    //         route.params.model = { title: this.$t(product) };
    //         return route
    //     }
    // };

    // ($("Comp.Products.LA.ProductSpec.FULProduct.PolicySearchForm.Policy.SearchConfig.AdvancedSearch.SearchResult.craView") || {}).targetRoute = {
    //     kind: "TExpr",
    //     async $eval() {
    //         const route = this.defaultRoute()
    //         const product = await this.$getProduct(this.$route.query.ProductDefID)
    //         route.name = product.policyForm.id
    //         route.params = {...route.params, formId: product.policyForm.id}
    //         route.params.model = { title: this.$t(product) };
    //         return route
    //     }
    // };

    /*       ULIP                    */
    // ($("Comp.Products.LA.ProductSpec.ULIPProduct.PolicySearchForm.Policy.AddNewPolicy") || {}).targetRoute = {
    //     kind: "TExpr",
    //     async $eval() {
    //         const route = this.defaultRoute()
    //         const product = await this.$getProduct(this.$route.query.ProductDefID);
    //         route.name = product.policyForm.id
    //         route.params = {...route.params, formId: product.policyForm.id}
    //         route.params.model = { ProductDefID: product.id, title: this.$t(product) };
    //         return route
    //     }
    // };
    // ($("Comp.Products.LA.ProductSpec.ULIPProduct.PolicySearchForm.Policy.SearchConfig.AdvancedSearch.SearchResult.craDelete") || {}).targetRoute = {
    //     kind: "TExpr",
    //     async $eval() {
    //         const route = this.defaultRoute()
    //         const product = await this.$getProduct(this.$route.query.ProductDefID)
    //         route.name = product.policyForm.id
    //         route.params = {...route.params, formId: product.policyForm.id}
    //         route.params.model = { title: this.$t(product) };
    //         return route
    //     }
    // };

    // ($("Comp.Products.LA.ProductSpec.ULIPProduct.PolicySearchForm.Policy.SearchConfig.AdvancedSearch.SearchResult.craEdit") || {}).targetRoute = {
    //     kind: "TExpr",
    //     async $eval() {
    //         const route = this.defaultRoute()
    //         const product = await this.$getProduct(this.$route.query.ProductDefID)
    //         route.name = product.policyForm.id
    //         route.params = {...route.params, formId: product.policyForm.id}
    //         route.params.model = { title: this.$t(product) };
    //         return route
    //     }
    // };

    // ($("Comp.Products.LA.ProductSpec.ULIPProduct.PolicySearchForm.Policy.SearchConfig.AdvancedSearch.SearchResult.craView") || {}).targetRoute = {
    //     kind: "TExpr",
    //     async $eval() {
    //         const route = this.defaultRoute()
    //         const product = await this.$getProduct(this.$route.query.ProductDefID)
    //         route.name = product.policyForm.id
    //         route.params = {...route.params, formId: product.policyForm.id}
    //         route.params.model = { title: this.$t(product) };
    //         return route
    //     }
    // };
    // /*       Personal Accident                    */
    // ($("Comp.Products.LA.ProductSpec.PersonalAccidentProduct.PolicySearchForm.Policy.AddNewPolicy") || {}).targetRoute = {
    //     kind: "TExpr",
    //     async $eval() {
    //         const route = this.defaultRoute()
    //         const product = await this.$getProduct(this.$route.query.ProductDefID);
    //         route.name = product.policyForm.id
    //         route.params = {...route.params, formId: product.policyForm.id}
    //         route.params.model = { ProductDefID: product.id, title: this.$t(product) };
    //         return route
    //     }
    // };
    // ($("Comp.Products.LA.ProductSpec.PersonalAccidentProduct.PolicySearchForm.Policy.SearchConfig.AdvancedSearch.SearchResult.craDelete") || {}).targetRoute = {
    //     kind: "TExpr",
    //     async $eval() {
    //         const route = this.defaultRoute()
    //         const product = await this.$getProduct(this.$route.query.ProductDefID)
    //         route.name = product.policyForm.id
    //         route.params = {...route.params, formId: product.policyForm.id}
    //         route.params.model = { title: this.$t(product) };
    //         return route
    //     }
    // };

    // ($("Comp.Products.LA.ProductSpec.PersonalAccidentProduct.PolicySearchForm.Policy.SearchConfig.AdvancedSearch.SearchResult.craEdit") || {}).targetRoute = {
    //     kind: "TExpr",
    //     async $eval() {
    //         const route = this.defaultRoute()
    //         const product = await this.$getProduct(this.$route.query.ProductDefID)
    //         route.name = product.policyForm.id
    //         route.params = {...route.params, formId: product.policyForm.id}
    //         route.params.model = { title: this.$t(product) };
    //         return route
    //     }
    // };

    // ($("Comp.Products.LA.ProductSpec.PersonalAccidentProduct.PolicySearchForm.Policy.SearchConfig.AdvancedSearch.SearchResult.craView") || {}).targetRoute = {
    //     kind: "TExpr",
    //     async $eval() {
    //         const route = this.defaultRoute()
    //         const product = await this.$getProduct(this.$route.query.ProductDefID)
    //         route.name = product.policyForm.id
    //         route.params = {...route.params, formId: product.policyForm.id}
    //         route.params.model = { title: this.$t(product) };
    //         return route
    //     }
    // };
    // /*       TermLife Product                   */
    // ($("Comp.Products.LA.ProductSpec.TermLifeProduct.PolicySearchForm.Policy.AddNewPolicy") || {}).targetRoute = {
    //     kind: "TExpr",
    //     async $eval() {
    //         const route = this.defaultRoute()
    //         const product = await this.$getProduct(this.$route.query.ProductDefID);
    //         route.name = product.policyForm.id
    //         route.params = {...route.params, formId: product.policyForm.id}
    //         route.params.model = { ProductDefID: product.id, title: this.$t(product) };
    //         return route
    //     }
    // };
    // ($("Comp.Products.LA.ProductSpec.TermLifeProduct.PolicySearchForm.Policy.SearchConfig.AdvancedSearch.SearchResult.craDelete") || {}).targetRoute = {
    //     kind: "TExpr",
    //     async $eval() {
    //         const route = this.defaultRoute()
    //         const product = await this.$getProduct(this.$route.query.ProductDefID)
    //         route.name = product.policyForm.id
    //         route.params = {...route.params, formId: product.policyForm.id}
    //         route.params.model = { title: this.$t(product) };
    //         return route
    //     }
    // };

    // ($("Comp.Products.LA.ProductSpec.TermLifeProduct.PolicySearchForm.Policy.SearchConfig.AdvancedSearch.SearchResult.craEdit") || {}).targetRoute = {
    //     kind: "TExpr",
    //     async $eval() {
    //         const route = this.defaultRoute()
    //         const product = await this.$getProduct(this.$route.query.ProductDefID)
    //         route.name = product.policyForm.id
    //         route.params = {...route.params, formId: product.policyForm.id}
    //         route.params.model = { title: this.$t(product) };
    //         return route
    //     }
    // };

    // ($("Comp.Products.LA.ProductSpec.TermLifeProduct.PolicySearchForm.Policy.SearchConfig.AdvancedSearch.SearchResult.craView") || {}).targetRoute = {
    //     kind: "TExpr",
    //     async $eval() {
    //         const route = this.defaultRoute()
    //         const product = await this.$getProduct(this.$route.query.ProductDefID)
    //         route.name = product.policyForm.id
    //         route.params = {...route.params, formId: product.policyForm.id}
    //         route.params.model = { title: this.$t(product) };
    //         return route
    //     }
    // };
    //     /*       TermLife Product                   */
    // ($("Comp.Products.LA.ProductSpec.IPPProduct.PolicySearchForm.Policy.AddNewPolicy") || {}).targetRoute = {
    //     kind: "TExpr",
    //     async $eval() {
    //         const route = this.defaultRoute()
    //         const product = await this.$getProduct(this.$route.query.ProductDefID);
    //         route.name = product.policyForm.id
    //         route.params = {...route.params, formId: product.policyForm.id}
    //         route.params.model = { ProductDefID: product.id, title: this.$t(product) };
    //         return route
    //     }
    // };
    // ($("Comp.Products.LA.ProductSpec.IPPProduct.PolicySearchForm.Policy.SearchConfig.AdvancedSearch.SearchResult.craDelete") || {}).targetRoute = {
    //     kind: "TExpr",
    //     async $eval() {
    //         const route = this.defaultRoute()
    //         const product = await this.$getProduct(this.$route.query.ProductDefID)
    //         route.name = product.policyForm.id
    //         route.params = {...route.params, formId: product.policyForm.id}
    //         route.params.model = { title: this.$t(product) };
    //         return route
    //     }
    // };

    // ($("Comp.Products.LA.ProductSpec.IPPProduct.PolicySearchForm.Policy.SearchConfig.AdvancedSearch.SearchResult.craEdit") || {}).targetRoute = {
    //     kind: "TExpr",
    //     async $eval() {
    //         const route = this.defaultRoute()
    //         const product = await this.$getProduct(this.$route.query.ProductDefID)
    //         route.name = product.policyForm.id
    //         route.params = {...route.params, formId: product.policyForm.id}
    //         route.params.model = { title: this.$t(product) };
    //         return route
    //     }
    // };

    // ($("Comp.Products.LA.ProductSpec.IPPProduct.PolicySearchForm.Policy.SearchConfig.AdvancedSearch.SearchResult.craView") || {}).targetRoute = {
    //     kind: "TExpr",
    //     async $eval() {
    //         const route = this.defaultRoute()
    //         const product = await this.$getProduct(this.$route.query.ProductDefID)
    //         route.name = product.policyForm.id
    //         route.params = {...route.params, formId: product.policyForm.id}
    //         route.params.model = { title: this.$t(product) };
    //         return route
    //     }
    // };
}

export {extend}